<template>
   <div class="adminPage EvalDForm EvalDirectorFormPage">
   <!-- MODAL INFORMACION -->
   <modal
      name="InfoModal"
      width="80%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="true"
      v-show="viewhtml"
      >
      <div class="modalContainer htmlModal" v-if="viewhtml">
      <button class="btnCancel modalCloseBtn" @click="closeModal">
      Cerrar
      </button>
      <div v-for="item of listHtml" :key="item.id">
         <div
            :id="'txt_' + item.id"
            v-html="item.value"
            v-if="item.show"
            />
         </div>
      </div>
   </modal>
   <!-- TITULO -->
   <div class="titlePage" v-if="formList">
      {{titleForm}}
   </div>
   <div class="detailPage" v-html="descForm" v-if="formList" />
      <!-- NOTIFICACIONES -->
      <va-notification
         v-if="formListNoForm"
         color="danger"
         class="refNoData"
         >
         El formulario solicitado no se encuentra activo.
      </va-notification>
      <va-notification
         v-if="formListAdd"
         color="info"
         class="refNoData"
         >
         Ha finalizado el proceso y se ha guardado su evaluación.
         <br><br>
         Se aplicó para los siguientes periodos académicos para el docente
         con idBanner {{ $session.get('evalDir').id_to_eval }}:
         <br><br>
         {{ teacherPeriodsData
         .map(period => period.periodData)
         .sort((a, b) => a - b)
         .join(', ')
         }}
      </va-notification>
      <va-notification
         v-if="formListsend"
         color="info"
         class="refNoData"
         >
         El formulario solicitado ya se encuentra diligenciado.
      </va-notification>
      <!-- FORMULARIO -->
      <div v-if="formList" class="adminCard">
         <div class="adminCardBody">
            <ValidationObserver ref="obsFieldsFiles">
               <FormCharact
                  :FieldsForm="listFormCharact"
                  :ModelForm="listFormCharactModel"
                  :method="executeProcess"
                  />
            </ValidationObserver>
            <div class="modalActions">
               <button
                  id="loadForm"
                  type="submit"
                  @click="sendForm"
                  class="loginbtn primaryBtn"
                  >
               Evaluar
               </button>
               <router-link
                  :to="'/admin/EvalDirector/'"
                  class="loginbtn secondaryBtn"
                  >
                  Regresar
               </router-link>
            </div>
         </div>
      </div>
      <div v-else class="adminCard">
         <div class="adminCardBody text-left">
            <button
               class="loginbtn secondaryBtn"
               @click="LinkReload"
               >
               <va-icon name="fa fa-arrow-left" size="16" />
               Regresar
            </button>
         </div>
      </div>
   </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
import FormCharact from '@/components/forms/Forms.vue'

export default({
  name: 'FormEvalDirector',
  components: {
    FormCharact,
  },
  data () {
    return {
      titleForm: '',
      descForm: null,
      // -------------------------
      renderComponent1: false,
      historyPerson: false,
      datForm: [],
      refObject: {},
      teacherPeriodsData: [],
      // -------------------------
      listFormCharact: [],
      listFormCharactQuestion: [],
      listFormCharactModel: {},
      listHtml: [],
      // -------------------------
      viewhtml: false,
      formList: true,
      formListsend: false,
      formListAdd: false,
      formListAddRestric: false,
      formListNoForm: false,
      // --------------------------
      teacherId: null,
    }
  },
  methods: {
    LinkReload () {
      this.$router.push('/admin/EvalDirector/')
    },
    sendForm () {
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsFiles.validate().then(results => {
          if (!results) {
            IberoHelpers.scrollToTop(0, 0)
            resolve(false)
          } else {
            this.refObject = {}
            let loader = this.$loading.show()
            for (var data in this.listFormCharactModel) {
              if (Array.isArray(this.listFormCharactModel[data])) {
                var coma = ''
                this.refObject[data] = ''
                for (var i = 0; i < this.listFormCharactModel[data].length; i++) {
                  if (this.listFormCharactModel[data][i] !== '') {
                    this.refObject[data] += coma + this.listFormCharactModel[data][i]
                    coma = ', '
                  }
                }
              } else if (data.indexOf('_Add') >= 1 && this.listFormCharactModel[data] !== '') {
                var newId = data.split('_')
                var idRefAdd = this.listFormCharact.findIndex(function (element) {
                  return element.id === data
                })
                if (this.refObject[newId[0] + '_' + newId[1]] === this.listFormCharact[idRefAdd].aditional) {
                  this.refObject[newId[0] + '_' + newId[1]] += ' - ' + this.listFormCharactModel[data]
                }
              } else if (this.listFormCharactModel[data] instanceof Date) {
                this.refObject[data] = IberoHelpers.dataObjDate(this.listFormCharactModel[data])
              } else if (this.listFormCharactModel[data] === true) {
                this.refObject[data] = 'Si'
              } else if (this.listFormCharactModel[data] === false) {
                this.refObject[data] = 'No'
              } else {
                this.refObject[data] = this.listFormCharactModel[data]
              }
            }

            // var addAnswer = IberoHelpers.insertFormAnswer(this.$store,
            // this.$session.get('evalDir').form,
            // this.$session.get('evalDir').id_person,
            // this.refObject, this.teacherId,
            // this.$session.get('evalDir').period,
            // this.$session.get('evalDir').signature)
            // addAnswer.then(Response => {
            // if (Response) {
            //     this.formList = false
            //     if (Response.data.message === 'Success') {
            //     this.formListAdd = true
            //     } else {
            //     this.formListAdd = true
            //     }
            //     IberoHelpers.scrollToTop(0, 0)
            //     resolve(true)
            // } else {
            //     resolve(false)
            // }
            // loader.hide()
            // })

            for (let i = 0; i < this.teacherPeriodsData.length; i++) {
              var addAnswer = IberoHelpers.insertFormAnswer(this.$store,
                this.$session.get('evalDir').form,
                this.$session.get('evalDir').id_person,
                this.refObject, this.teacherId,
                this.teacherPeriodsData[i].periodData,
                this.teacherPeriodsData[i].codeData)
              addAnswer.then(Response => {
                if (Response) {
                  this.formList = false
                  if (Response.data.message === 'Success') {
                    this.formListAdd = true
                  } else {
                    this.formListAdd = true
                  }
                  IberoHelpers.scrollToTop(0, 0)
                  resolve(true)
                } else {
                  resolve(false)
                }
                loader.hide()
              })
            }
          }
        })
      })
    },
    setObjectlist (valorum) {
      var DataArray = ''
      var infolist = []
      DataArray = valorum.split('|')
      for (var i = 0; i < DataArray.length; i++) {
        infolist.push(
          { id: DataArray[i], value: DataArray[i] }
        )
      }
      return infolist
    },
    executeHistory () {
      this.$modal.show('HistoryModal')
    },
    loadForm (data) {
      this.listFormCharact.length = 0
      for (var i = 0; i < data.length; i++) {
        var validateRef = ''
        var validatePicker = {}
        var listData = ''
        var refRegis = 'id_' + data[i].Id_Generic_Form_Question
        var Datplaceholder = data[i].Nam_Generic_Form
        if (data[i].Det_Validate_Generic_Form !== '') {
          validateRef = JSON.parse(data[i].Det_Validate_Generic_Form)
        }
        if (data[i].Type_Generic_Form === 'radio' || data[i].Type_Generic_Form === 'Select') {
          listData = this.setObjectlist(data[i].Det_Data_Generic_Form)
          this.listFormCharactModel[refRegis] = ''
        } else if (data[i].Type_Generic_Form === 'datepicker') {
          this.listFormCharactModel[refRegis] = ''
          validatePicker.format = this.$store.state.dateFormat
          validatePicker.disabledDates = {
            to: new Date(1900, 0, 1),
            from: new Date(),
          }
        } else if (data[i].Type_Generic_Form === 'title') {
          this.listFormCharactModel[refRegis] = data[i].Nam_Generic_Form
        } else if (data[i].Type_Generic_Form === 'accepted') {
          Datplaceholder = data[i].Det_Data_Generic_Form
          if (data[i].Sta_Aditional_Generic_Form) {
            this.listHtml.push({ id: 'cbox_' + refRegis, value: data[i].Det_Generic_Form, show: false })
            Datplaceholder = Datplaceholder.replace('[', '<a class="linkTerm">').replace(']', '</a>')
          }
          listData = 'Si'
        } else if (data[i].Type_Generic_Form === 'check') {
          listData = this.setObjectlist(data[i].Det_Data_Generic_Form)
          this.listFormCharactModel[refRegis] = []
        } else {
          this.listFormCharactModel[refRegis] = ''
        }
        this.listFormCharact.push({
          id: refRegis,
          name: data[i].Nam_Generic_Form,
          type: data[i].Type_Generic_Form,
          class: data[i].Det_Data_Generic_Class,
          placeholder: Datplaceholder,
          values: listData,
          model: refRegis,
          validate: validateRef,
          dateTimePickerOptions: validatePicker,
          tooltip: data[i].Det_Generic_Form_Tooltip,
          disabled: false,
        })
        if (data[i].Sta_Aditional_Generic_Form && data[i].Type_Generic_Form === 'radio') {
          var aditional = data[i].Det_Data_Generic_Form.split('=')
          this.listFormCharactModel[refRegis + '_Add'] = ''
          this.listFormCharact.push({
            id: refRegis + '_Add',
            aditional: aditional[0],
            name: aditional[1],
            type: 'inputAdd',
            class: data[i].Det_Data_Generic_Class + ' noShow',
            placeholder: aditional[1],
            values: aditional[0],
            model: refRegis + '_Add',
            validate: { required: false },
          })
        }
        this.formList = true
      }
    },
    closeModal () {
      this.viewhtml = false
    },
    executeProcess (event, refer) {
      var infoRef = document.getElementById(event.target.name + '_Add')
      if (infoRef !== null) {
        var listData = this.listFormCharact.find(function (element) {
          return element.id === infoRef.id
        })
        if (event.target.value === infoRef.getAttribute('idvalidate')) {
          document.getElementById('div_' + event.target.name + '_Add').classList.remove('noShow')
          listData.validate.required = true
        } else {
          document.getElementById('div_' + event.target.name + '_Add').classList.add('noShow')
          listData.validate.required = false
        }
      } else {
        var findType = event.target.id.indexOf('cbox_')
        if (findType === 0) {
          this.$modal.hide('InfoModal')
          this.viewhtml = false
          this.listHtml.forEach(element => {
            if (element.id === event.target.id) {
              element.show = true
            } else {
              element.show = false
            }
          })
          this.viewhtml = true
          if (event.target.checked === true) {
            this.$modal.show('InfoModal')
          } else {
            this.listFormCharactModel[event.target.id.replace('cbox_', '')] = ''
          }
        }
      }
    },
    loadTeacherPeriods () {
      const d = new Date()
      let year = d.getFullYear()
      let isEspecialYear = this.$session.get('evalDir').period.toString().slice(0, 4)
      let validatedYear = null
      let isEspecialCase = false

      if (year === parseInt(isEspecialYear)) {
        validatedYear = year
      } else {
        validatedYear = isEspecialYear
        isEspecialCase = true
      }
      const validPeriodEndings = [17, 35, 45, 55]

      let formSSS = IberoHelpers.GetTeacherPeriodsCodigoPrograma(this.$store, this.$session.get('evalDir').id_to_eval, validatedYear)

      formSSS.then(async dataFormRR => {
        for (let i = 0; i < dataFormRR.data.length; i++) {
          let periodData = dataFormRR.data[i].periodo
          if (isEspecialCase) {
            console.log('periodo ingresado: ' + periodData)
            let periodEnding = parseInt(periodData.slice(-2))
            console.log('periodo slice: ' + periodEnding) // Extraer los últimos 2 dígitos
            if (!validPeriodEndings.includes(periodEnding)) {
              console.log('periodo omitido por la lista:' + periodData)
              continue // Saltar este período si no está en la lista de válidos
            }
          }
          let exists = this.teacherPeriodsData.some(item => item.periodData === periodData)
          if (!exists) {
            let responseExist = await IberoHelpers.GetFormSuccessDDV(this.$store, 0, this.$session.get('evalDir').id_to_eval, periodData, this.$session.get('evalDir').signature.toUpperCase())

            if (!responseExist.data) {
              let objct = {
                periodData: periodData,
                codeData: this.$session.get('evalDir').signature,
              }
              this.teacherPeriodsData.push(objct)
            }
          }
        }
        console.log(this.teacherPeriodsData)
      })
    },
  },
  mounted () {
    this.loadTeacherPeriods()
    let loader = this.$loading.show()

    // var formS = IberoHelpers.GetFormSuccess(this.$store, this.$session.get('IberoJWTAdminLogin').idPerson, this.$session.get('evalDo').period, this.$session.get('evalDo').period)
    // var formS = IberoHelpers.GetFormSuccess(this.$store, 206330, this.$session.get('evalDir').period, this.$session.get('evalDir').signature)
    let formS = IberoHelpers.GetFormSuccessDDV(this.$store, 0, this.$session.get('evalDir').id_to_eval, this.$session.get('evalDir').period, this.$session.get('evalDir').signature.toUpperCase())
    formS.then(dataFormR => {
      console.log(dataFormR)
      if (dataFormR.data) {
        this.formList = false
        this.formListsend = true
      }
      if (!this.formListsend) {
        /* ------------------------------------------------- */
        this.teacherId = this.$session.get('evalDir').id_to_eval
        /* ------------------------------------------------- */
        const datEvalForm = IberoHelpers.getEvalForm(this.$store, this.$session.get('evalDir').role, this.$session.get('evalDir').period.substring(0, 4), this.$session.get('evalDir').form_type)
        datEvalForm.then(Response => {
          if (Response.data !== '') {
            this.titleForm = Response.data[0].Nam_Form
            this.descForm = Response.data[0].Det_Form

            if (Response.data.Sta_Update_Form === false && this.historyPerson === false) {
              this.formList = false
              this.formListsend = true
            } else {
              const formQuestion = IberoHelpers.getEvalFormQuestion(this.$store, Response.data[0].Id_Generic_Form)
              formQuestion.then(formQuestionData => {
                let questions = []
                for (let i = 0; i < formQuestionData.data.length; i++) {
                  questions.push(formQuestionData.data[i])
                }
                this.loadForm(questions)
              })
            }
            loader.hide()
          } else {
            this.titleForm = 'Formulario evaluación docente'
            this.formListNoForm = true
            this.formListsend = false
            this.formList = false
          }
        })
      }
    })
    loader.hide()
  },
  beforeUnmount () {
    this.$session.set('evalDir', '')
  },
})
</script>
